export default `
<span class="hidden-menu" >
  <button class="hidden-menu-trigger" id="hiddenMenuBtn-{{::$id}}" tabindex="0" aria-label="Edit" aria-haspopup="true" aria-controls="hiddenMenuList-{{::$id}}" aria-expanded="{{$ctrl.menuOpen}}" ng-keydown="$ctrl.handleKeyDown($event)" ng-click="$ctrl.toggleHiddenMenu($event)" ng-blur="$ctrl.onBlur()">
    <i ng-class="$ctrl.iconClass" aria-hidden="true">{{$ctrl.iconName}}</i> {{itemCount}}
  </button>
  <ul ng-class="{active: $ctrl.menuOpen}" ng-transclude role="menu" id="hiddenMenuList-{{::$id}}" aria-labelledby="hiddenMenuBtn-{{::$id}}" aria-hidden="true"></ul>
</span>
`;
